import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import circle from '../../assets/images/shop_banner_circle.png';

const StyledContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 120px;
	border-radius: 5px;
	padding: 30px 500px 30px 40px;
	background-color: #17312f;
	overflow: hidden;

	@media (max-width: 1280px) {
		padding: 30px 400px 30px 40px;
	}
`;

const StyledBannerTextContainer = styled.div`
	position: relative;
	z-index: 4;
	display: flex;
	flex-direction: column;
	gap: 10px;

	${Text} {
		&:first-child {
			font-weight: 500;
			font-size: 16px;
			color: #ffffff;
		}

		&:last-child {
			max-width: 540px;
			font-style: italic;
			font-weight: 400;
			font-size: 14px;
			color: #ffffff;
			opacity: 0.5;
		}
	}
`;

const StyledTimerContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 13px;

	img {
		width: 13px;
		height: 14px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledRightContainer = styled.div`
	position: relative;
	z-index: 4;
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledDot = styled.div`
	width: 6px;
	height: 6px;
	background-color: #ffffff;
	opacity: 0.1;
	border-radius: 6px;
`;

const StyledBGText = styled.div`
	position: absolute;
	z-index: 2;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-family: 'GT Walsheim Pro';
	font-style: italic;
	font-weight: 700;
	font-size: 172px;
	line-height: 197px;
	opacity: 0.05;
	white-space: nowrap;
	user-select: none;
	pointer-events: none;
	mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
	-webkit-mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
	color: #ffffff;
	text-transform: uppercase;
`;

const StyledCaseImageContainer = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: 0;
	z-index: 3;
	width: 512px;
	height: 512px;
`;

const StyledCaseBG = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 860px;
	height: 860px;
	background-image: url(${circle});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

export {
	StyledBannerTextContainer,
	StyledBGText,
	StyledCaseBG,
	StyledCaseImageContainer,
	StyledContainer,
	StyledDot,
	StyledRightContainer,
	StyledTimerContainer,
};
